export const UniqueProductLabelId = {
    "FEATURED": 1,
    "POPULAR": 2,
    "PREORDER_ONLY": 3,
    "GLUTEN_FREE": 34,
    "VEGAN": 35,
    "VEGETARIAN": 36
}